import { generatePath, useHistory } from 'react-router-dom';
import { Button } from '@accure/ui/components/button/button-catalyst';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { useBoolean } from 'usehooks-ts';

import { FullPageContent } from '@/components/layout/full-page-content';
import { FormEditAsset } from '@/components/pages/assets/overview/form-edit-asset';
import { Card } from '@/components/ui/card';
import { useBlockNavigation } from '@/hooks/use-block-navigation';
import { useCurrentAsset } from '@/hooks/use-current-asset';
import { siteLabel } from '@/utils/format/customer';

export function EditAssetPage() {
  const { asset, assetId } = useCurrentAsset();
  const history = useHistory();
  const isDirty = useBoolean();
  useBlockNavigation({
    isDirty: isDirty.value,
  });

  if (!assetId || !asset) {
    return null;
  }

  return (
    <FullPageContent scrollable={true} className="bg-zinc-50">
      <div className="mx-auto my-4 max-w-5xl">
        <Button
          plain
          className="-ml-4"
          onClick={() =>
            (window.location.href = generatePath('/asset/:assetId/overview', {
              assetId,
            }))
          }
        >
          <ChevronLeftIcon />
          Back to Asset Overview
        </Button>
        <div className="py-8">
          <div className="mb-2 font-condensed text-2xl font-bold">
            Edit Asset Details
          </div>
          <div className="max-w-prose text-lg text-zinc-500">
            Edit asset configuration and upload an image to identify the site.
            Update specs, timeline, and location as needed.
          </div>
        </div>
        <Card>
          <div className="mb-6 font-condensed text-2xl font-bold">
            {siteLabel(asset.fullFrontendId)}
          </div>
          <FormEditAsset
            onSuccess={() =>
              history.push(
                generatePath('/asset/:assetId/overview', { assetId }),
              )
            }
            onChange={(state) => isDirty.setValue(state.isDirty)}
            onConfirmCancel={history.goBack}
          />
        </Card>
      </div>
    </FullPageContent>
  );
}
